import { SectionName } from '../../../observability/tracking/events';
import { withTracking } from '../../../observability';
import { createBuilderModule } from '../../../builder';
import { FAQSection } from './FAQSection';
import { ITEMS } from './fixtures';
import { COLOR_KEYS } from '../../../constants';

export default createBuilderModule(
  withTracking(FAQSection, {
    as: 'section',
    sectionName: SectionName.FAQSection,
  }),
  {
    image: 'https://cdn.zappy.app/7ef8f81d88de7e12ae874ffeb96c8452.png',
    inputs: [
      {
        defaultValue: 'FAQ',
        name: 'title',
        required: true,
        type: 'string',
      },
      {
        defaultValue: COLOR_KEYS.neutral100,
        enum: [
          COLOR_KEYS.blue10,
          COLOR_KEYS.cream,
          COLOR_KEYS.neutral100,
          COLOR_KEYS.neutral200,
        ],
        name: 'backgroundColor',
        type: 'string',
      },
      {
        defaultValue: true,
        helperText:
          "Determines whether two accordion 'drawers' can be open at the same time or if opening one automatically closes any other open drawer.",
        name: 'autoClose',
        type: 'boolean',
      },
      {
        defaultValue: [ITEMS[0]],
        name: 'items',
        required: true,
        subFields: [
          {
            name: 'title',
            required: true,
            type: 'string',
          },
          {
            name: 'content',
            required: true,
            type: 'richText',
          },
          {
            helperText:
              'Optional link, visible as icon next to/under (depends on viewport) the content when open.',
            name: 'href',
            type: 'string',
          },
          {
            helperText:
              'Optional text to display for the link below the content.',
            name: 'linkText',
            type: 'string',
          },
        ],
        type: 'list',
      },
    ],
    name: 'FAQSection',
  },
);
